import useOnClickOutside from "../../utils/hooks/useOnClickOutside.es.js";
import useOnFocusOutside from "../../utils/hooks/useOnFocusOutside.es.js";
function useCloseOnBlur(options) {
  const onBlur = () => {
    if (options.shouldCloseOnBlur && options.onClose) options.onClose();
  };
  useOnClickOutside(onBlur, options.refs);
  useOnFocusOutside(onBlur, options.refs);
}
export {
  useCloseOnBlur
};
//# sourceMappingURL=useCloseOnBlur.es.js.map
